import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const SEOIntroductionParagraphModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "seo-text" */
            './'
        )
    ),
    componentName: 'SEOIntroductionParagraph',
});
export default SEOIntroductionParagraphModule;
